import React, { useState } from 'react';
import { Info, X } from 'lucide-react';

const PAGE_HELP = {
    dashboard: { title: 'Dashboard', text: 'Visão geral do sistema. Acompanhe KPIs, atividade recente, saúde dos serviços e ações rápidas.' },
    campanhas: { title: 'Campanhas', text: 'Crie e gerencie campanhas de divulgação. Defina metas, acompanhe resultados e otimize sua estratégia.' },
    gestao: { title: 'Gestão Financeira', text: 'Controle receitas, despesas e relatórios. Exporte dados em CSV e acompanhe a saúde financeira.' },
    conexoes: { title: 'Conexões', text: 'Configure integrações: Telegram Bot, WhatsApp, Discord e outras plataformas de comunicação.' },
    comunidades: { title: 'Comunidades', text: 'Publique ofertas em plataformas como Promobit e Pelando. Configure modos de postagem por plataforma.' },
    automacoes: { title: 'Automações', text: 'Configure regras automáticas para publicação, notificação e distribuição de ofertas.' },
    performance: { title: 'Performance', text: 'Analise métricas de desempenho: cliques, conversões, engajamento e ROI das campanhas.' },
    templates: { title: 'Templates', text: 'Crie e gerencie modelos de mensagem para Telegram, email e outras plataformas.' },
    pesquisas: { title: 'Pesquisas Focadas', text: 'Configure buscas automáticas por produtos e ofertas específicas de interesse.' },
    usuarios: { title: 'Usuários', text: 'Gerencie usuários do sistema. Aprove acessos, defina perfis e acompanhe atividade.' },
    configurações: { title: 'Configurações', text: 'Ajuste email, Telegram, crawler, botões de link e demais opções do sistema.' },
    conta: { title: 'Minha Conta', text: 'Edite seu perfil, altere senha e gerencie biometria para login rápido.' },
    descobertas: { title: 'Descobertas', text: 'Revise ofertas encontradas pelo crawler. Aprove, rejeite ou envie para publicação.' },
    alertas: { title: 'Alertas', text: 'Configure alertas personalizados para receber notificações de ofertas relevantes.' },
    suporte: { title: 'Suporte', text: 'Precisa de ajuda? Entre em contato ou consulte a documentação do sistema.' },
};

export function PageHelp({ pageKey }) {
    const [open, setOpen] = useState(false);
    const help = PAGE_HELP[pageKey];
    if (!help) return null;

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="w-7 h-7 rounded-full flex items-center justify-center transition-all hover:scale-110"
                style={{ background: 'var(--surface-2)', border: '1px solid var(--border)' }}
                title={`Ajuda: ${help.title}`}
                data-testid={`help-btn-${pageKey}`}
            >
                <Info size={13} style={{ color: 'var(--muted-2)' }} />
            </button>

            {open && (
                <div className="fixed inset-0 z-[9999] flex items-start justify-center pt-24" onClick={() => setOpen(false)}>
                    <div className="absolute inset-0 bg-black/40" />
                    <div
                        className="relative max-w-sm w-full mx-4 p-5 rounded-xl"
                        style={{ background: 'var(--surface)', border: '1px solid var(--border)', boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}
                        onClick={e => e.stopPropagation()}
                    >
                        <button onClick={() => setOpen(false)} className="absolute top-3 right-3 p-1 rounded-lg" style={{ color: 'var(--muted-2)' }}>
                            <X size={14} />
                        </button>
                        <h3 className="text-sm font-bold mb-2" style={{ color: 'var(--gold-2)' }}>{help.title}</h3>
                        <p className="text-xs leading-relaxed" style={{ color: 'var(--muted)' }}>{help.text}</p>
                    </div>
                </div>
            )}
        </>
    );
}
